import React from "react";
import { motion } from "framer-motion";
import {
  HiTrophy,
  HiClipboardDocumentList,
  HiPaintBrush,
  HiChevronDown,
  HiChevronUp,
} from "react-icons/hi2";
import { BiLogoGraphql } from "react-icons/bi";
import { FaMedal, FaAward } from "react-icons/fa";

// Toggle this to show/hide project specifications
const DISPLAY_PROJECTS = false; // Set to true to reveal projects

// Import project data conditionally - will be null if file is hidden
let projectPhases = null;
try {
  const projectData = require("../data/projects");
  projectPhases = projectData.projectPhases;
} catch (error) {
  // projects.js is hidden/not available
  projectPhases = null;
}

const Rubric = () => {
  const [expandedProjects, setExpandedProjects] = React.useState({});

  const toggleProjectExpansion = (projectId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };
  return (
    <div className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Competition Structure Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Event Format
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Understand the 3-stage competition format and how participants
            advance to the finals.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Stage 1: Core Projects */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg dark:shadow-gray-800/50 h-full flex flex-col border border-gray-200 dark:border-gray-700"
          >
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 border-b-2 border-aifund pb-2">
              Stage 1: Core Projects
            </h3>

            <div className="space-y-4">
              <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border-l-4 border-green-500 min-h-[120px] flex flex-col justify-center">
                <div className="font-bold text-green-600 dark:text-green-400 text-lg mb-2">
                  5 Projects
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                  All participants must complete all 5 core projects by the
                  specified timeline to qualify for semifinals.
                </p>
              </div>
              {/*
              <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg min-h-[140px]">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
                  Project Focus Areas:
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                  <li>• AI Model Implementation</li>
                  <li>• Data Processing & Analysis</li>
                  <li>• User Interface Development</li>
                  <li>• Integration & APIs</li>
                  <li>• Testing & Documentation</li>
                </ul>
              </div>
              */}
            </div>

            <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border-l-4 border-green-500 min-h-[80px] flex items-center">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                <strong>Success Criteria:</strong> Participants/teams that
                complete all 5 core projects advance to the semifinals.
              </p>
            </div>
          </motion.div>

          {/* Stage 2: Challenge Project */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg dark:shadow-gray-800/50 h-full flex flex-col border border-gray-200 dark:border-gray-700"
          >
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 border-b-2 border-aifund pb-2">
              Stage 2: Semifinals
            </h3>

            <div className="space-y-4">
              <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border-l-4 border-yellow-500 min-h-[120px] flex flex-col justify-center">
                <div className="font-bold text-yellow-600 dark:text-yellow-400 text-lg mb-2">
                  Speed Challenge
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                  Qualifying participants receive an additional semifinal
                  project to complete.
                </p>
              </div>
              {/*
              <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg min-h-[140px]">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
                  Challenge Features:
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                  <li>• Time-based competition</li>
                  <li>• Advanced AI integration</li>
                  <li>• Real-world problem solving</li>
                  <li>• Performance optimization</li>
                  <li>• Innovation encouraged</li>
                </ul>
              </div>
              */}
            </div>

            <div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border-l-4 border-yellow-500 min-h-[80px] flex items-center">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                <strong>Success Criteria:</strong> First 5 participants/teams to
                complete the project advance to Finals.
              </p>
            </div>
          </motion.div>

          {/* Stage 3: Finals */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg dark:shadow-gray-800/50 h-full flex flex-col border border-gray-200 dark:border-gray-700"
          >
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 border-b-2 border-aifund pb-2">
              Stage 3: Finals
            </h3>

            <div className="space-y-4">
              <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border-l-4 border-red-500 min-h-[120px] flex flex-col justify-center">
                <div className="font-bold text-red-600 dark:text-red-400 text-lg mb-2">
                  Live Demo Presentations
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                  Each finalist (whether competing as an individual or as part
                  of a team) presents their original 5 core projects on stage in
                  a 10-minute presentation to an expert panel.
                </p>
              </div>
              {/*}
              <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg min-h-[140px]">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
                  Evaluation Criteria:
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                  <li>• Technical implementation</li>
                  <li>• Innovation & creativity</li>
                  <li>• User experience design</li>
                  <li>• Presentation quality</li>
                  <li>• Real-world applicability</li>
                </ul>
              </div>
              */}
            </div>

            <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border-l-4 border-red-500 min-h-[80px] flex items-center">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                <strong>Success Criteria:</strong> The solo participant or team
                with the highest points wins based on an expert panel evaluation
                of technical excellence and innovation. In the event of a tie,
                the participant or team which completed the semifinal project
                the fastest will be named the winner.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Project Details Section - Only show if display is enabled and project data is available */}
        {DISPLAY_PROJECTS && projectPhases && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            viewport={{ once: true }}
            className="mt-16 mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
              Qualifying Round Projects
            </h2>

            {/* Qualifying Round Projects */}
            <div className="mb-12">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {projectPhases.qualifying.projects.map((project, index) => (
                  <motion.div
                    key={project.id}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 * (index + 1) }}
                    viewport={{ once: true }}
                    className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-xl transition-shadow duration-200"
                    onClick={() => toggleProjectExpansion(project.id)}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        {project.isCore && project.iconComponent && (
                          <div className="bg-aifund text-white p-2 rounded-full mr-3 flex items-center justify-center">
                            <project.iconComponent className="w-4 h-4" />
                          </div>
                        )}
                        <h4 className="text-lg font-bold text-gray-900 dark:text-white">
                          {project.title}
                        </h4>
                      </div>
                      <div className="text-gray-500 dark:text-gray-400">
                        {expandedProjects[project.id] ? (
                          <HiChevronUp className="w-5 h-5" />
                        ) : (
                          <HiChevronDown className="w-5 h-5" />
                        )}
                      </div>
                    </div>
                    <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                      {project.description}
                    </p>
                    {expandedProjects[project.id] && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="border-t border-gray-200 dark:border-gray-600 pt-4">
                          <h5 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                            Requirements:
                          </h5>
                          <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                            {project.requirements.map(
                              (requirement, reqIndex) => (
                                <li key={reqIndex}>• {requirement}</li>
                              )
                            )}
                          </ul>
                        </div>
                      </motion.div>
                    )}
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Semifinal Project */}
            <div className="mb-12">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
                {projectPhases.semifinal.title}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                  viewport={{ once: true }}
                  className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-xl transition-shadow duration-200"
                  onClick={() =>
                    toggleProjectExpansion(projectPhases.semifinal.project.id)
                  }
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      {projectPhases.semifinal.project.iconComponent && (
                        <div className="bg-aifund text-white p-2 rounded-full mr-3 flex items-center justify-center">
                          <projectPhases.semifinal.project.iconComponent className="w-4 h-4" />
                        </div>
                      )}
                      <h4 className="text-lg font-bold text-gray-900 dark:text-white">
                        {projectPhases.semifinal.project.title}
                      </h4>
                    </div>
                    <div className="text-gray-500 dark:text-gray-400">
                      {expandedProjects[projectPhases.semifinal.project.id] ? (
                        <HiChevronUp className="w-5 h-5" />
                      ) : (
                        <HiChevronDown className="w-5 h-5" />
                      )}
                    </div>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                    {projectPhases.semifinal.project.description}
                  </p>
                  {expandedProjects[projectPhases.semifinal.project.id] && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="border-t border-gray-200 dark:border-gray-600 pt-4">
                        <h5 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                          Requirements:
                        </h5>
                        <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                          {projectPhases.semifinal.project.requirements.map(
                            (requirement, reqIndex) => (
                              <li key={reqIndex}>• {requirement}</li>
                            )
                          )}
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </motion.div>
              </div>
            </div>
          </motion.div>
        )}

        {/* Prizes Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-12 text-center">
            Prizes & Awards
          </h2>

          {/* Top Row - First and Second Place */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-8">
            {/* Highest Points Award */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 rounded-xl p-6 border-2 border-yellow-300 dark:border-yellow-600 shadow-md dark:shadow-gray-800/50"
            >
              <div className="text-center">
                <div className="text-4xl mb-3 flex justify-center">
                  <FaMedal className="text-yellow-500 dark:text-yellow-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  First Place Award
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  Sponsored by Replit. Individual or team with the highest
                  points across the Stage 1 projects
                </p>
                <div className="text-lg font-semibold text-yellow-600 dark:text-yellow-400">
                  $1,000
                </div>
              </div>
            </motion.div>

            {/* Second Place Award */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              viewport={{ once: true }}
              className="bg-gray-100 dark:bg-gray-800 rounded-xl p-6 border-2 border-gray-300 dark:border-gray-600 shadow-md dark:shadow-gray-800/50"
            >
              <div className="text-center">
                <div className="text-4xl mb-3 flex justify-center">
                  <FaAward className="text-gray-500 dark:text-gray-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Second Place Award
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  Individual or team with the with second highest points across
                  the Stage 1 projects
                </p>
                <div className="text-lg font-semibold text-gray-600 dark:text-gray-400">
                  $500
                </div>
              </div>
            </motion.div>
          </div>

          {/* Bottom Row - Other Awards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Solo Participant Award */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-xl p-6 border-2 border-blue-300 dark:border-blue-600 shadow-md dark:shadow-gray-800/50"
            >
              <div className="text-center">
                <div className="text-4xl mb-3 flex justify-center">
                  <HiTrophy className="text-blue-500 dark:text-blue-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Solo Participant Award
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  Solo participant with the highest points receives $500
                </p>
                <div className="text-lg font-semibold text-blue-600 dark:text-blue-400">
                  $500
                </div>
              </div>
            </motion.div>

            {/* Best Design Award */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-6 border-2 border-purple-300 dark:border-purple-600 shadow-md dark:shadow-gray-800/50"
            >
              <div className="text-center">
                <div className="text-4xl mb-3 flex justify-center">
                  <HiPaintBrush className="text-purple-500 dark:text-purple-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Best Design Award
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  Recognizing outstanding project design and user experience
                </p>
                <div className="text-lg font-semibold text-purple-600 dark:text-purple-400">
                  $500
                </div>
              </div>
            </motion.div>

            {/* Neo4j Award */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-xl p-6 border-2 border-green-300 dark:border-green-600 shadow-md dark:shadow-gray-800/50"
            >
              <div className="text-center">
                <div className="text-4xl mb-3 flex justify-center">
                  <BiLogoGraphql className="text-green-500 dark:text-green-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Graph Thinking Award
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  Sponsored by Neo4j. Best use of a knowledge graph for
                  information representation and retrieval. (submit one project
                  to qualify)
                </p>
                <div className="text-lg font-semibold text-green-600 dark:text-green-400">
                  $500
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Rubric;
